import * as Yup from "yup";

export const homeMagHomeFormSchema = Yup.object().shape({
  from: Yup.date().required("لطفا تاریخ شروع را مشخص کنید"),
  to: Yup.date().required("لطفا تاریخ پایان را مشخص کنید"),
});

export const magHomeBannerFormSchema = Yup.object().shape({
  name: Yup.string().required("لطفا عنوان بنر را وارد کنید"),
  url: Yup.string().required("لطفا لینک بنر را وارد کنید"),
  description: Yup.string().required("لطفا توضیحات بنر را وارد کنید"),
});
